import React from "react";
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";

const ViewForm = ({ Modalclose, modalData }) => {
  if (!modalData) {
    return null; // or return some default content if modalData is null or undefined
  }

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>Ads Details</h1>
          <div className="close-icon">
            <FaWindowClose onClick={Modalclose} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <section className="view-blog view-sec">
                <div className="container">
                  <div className="mt-3 view-text">
                    <label className="heading">Title </label>
                    <p>{modalData.title}</p>
                    {modalData.ShortDescription && (
                      <>
                        <label className="heading">ShortDescription</label>
                        <p>{modalData.ShortDescription}</p>
                      </>
                    )}
                    {modalData.description && (
                      <>
                        <label className="heading"> Description</label>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: modalData.description || "",
                          }}
                        />
                      </>
                    )}
                    {modalData.thumbnail_image && (
                      <>
                        <label className="heading">Ads Image</label>

                        <img
                          src={`${modalData.thumbnail_image}?${Date.now()}`}
                          alt="Thumbnail"
                        />
                      </>
                    )}

                    <label className="heading">Status</label>
                    <div className="status-details">
                      <span
                        className={`status ${
                          modalData.status ? "active" : "inactive"
                        }`}
                      >
                        {modalData.status ? "active" : "inactive"}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ViewForm;
